import React from 'react';
import {useStoreState} from 'easy-peasy';
import {isMobile} from 'mobile-device-detect';

const LegalFooter = props => {
    const path = useStoreState(state => state.path.current);

    return (
        <section
            style={{display: path === `/results` && props.from === `app` ? `none` : `flex`, paddingBottom: isMobile ? `5rem` : 0}}
            className={path === `/results` ? `results-legal-container` : `legal-container`} >
            <div className="legal-links">
                <a target="_blank" href="https://www.guardianlife.com/terms-conditions" rel="noopener noreferrer">Terms &amp; conditions</a>
                <a target="_blank" href="https://www.guardianlife.com/privacy-policy" rel="noopener noreferrer">Privacy policy</a>
                <a target="_blank" href="https://www.guardianlife.com/disclosures" rel="noopener noreferrer">Disclosures</a>
                <a target="_blank" href="https://www.guardianlife.com/data-security" rel="noopener noreferrer">Data security</a>
                <a target="_blank" href="https://www.guardianlife.com/accessibility" rel="noopener noreferrer">Accessibility</a>
                <a target="_blank" href="https://www.guardianlife.com/telehealth" rel="noopener noreferrer">Telehealth</a>
                <a target="_blank" href="https://www.guardianlife.com/ny-reg-200" rel="noopener noreferrer">NY Reg. 200</a>
                <a target="_blank" href="https://www.guardianlife.com/confidentiality-policy" rel="noopener noreferrer">Confidentiality for domestic violence victims</a>
                <a target="_blank" href="https://www.orderroutingdisclosure.com/" rel="noopener noreferrer">SEC Rule 606</a>
                <a target="_blank" href="https://www.guardianlife.com/guardian-group-status" rel="noopener noreferrer">Legal notices &amp; disclaimers</a>
                <p>&copy; 2019, The Guardian Life Insurance Company of America, New York, NY. All rights reserved. 2019-89196</p>
            </div>
        </section>
    );
};

export default LegalFooter;
